import CompareOtherProductsPanel from './CompareOtherProductsPanel';

export default CompareOtherProductsPanel;
